<template>
  <div>
    <b-modal
      id="prepare-form-send-email"
      ref="modal-prepare-form-send-email"
      content-class=""
      modal-class="modal-order-refund-list"
      cancel-variant=""
      ok-title="ok-title"
      cancel-title="cancel-title"
      centered
      hide-footer
      hide-header-close
      title="Редактирование Email"
    >
      <!-- Name -->
<!--      <validation-provider-->
<!--        #default="validationContext"-->
<!--        name="Имя"-->
<!--        rules=""-->
<!--        vid="name"-->
<!--      >-->
<!--        <b-form-group-->
<!--          label="Имя"-->
<!--          label-for="name"-->
<!--        >-->
<!--          <b-form-input-->
<!--            id="name"-->
<!--            v-model="FORM_DATA.name"-->
<!--            autofocus-->
<!--            :state="getValidationState(validationContext)"-->
<!--            trim-->
<!--            placeholder=""-->
<!--          />-->
<!--          <b-form-invalid-feedback>-->
<!--            {{ validationContext.errors[0] }}-->
<!--          </b-form-invalid-feedback>-->
<!--        </b-form-group>-->
<!--      </validation-provider>-->

      <!-- Email -->
      <validation-provider
        #default="validationContext"
        name="Email"
        rules="required|email:rfc,dns"
        vid="email"
      >
        <b-form-group
          label="Email *"
          label-for="email"
        >
          <b-form-input
            id="email"
            v-model="FORM_DATA.email"
            autofocus
            :state="getValidationState(validationContext)"
            trim
            placeholder=""
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- Добавить ссылку на личный кабинет -->
      <validation-provider
        #default="validationContext"
        name="Добавить ссылку на личный кабинет"
        rules=""
        vid="is_add_link"
      >
        <b-form-group
          label=""
          label-for="is_add_link"
        >
          <b-form-checkbox
            id="upd-intermission"
            v-model="FORM_DATA.is_add_link"
            name="is_add_link"
            :value="1"
            :unchecked-value="0"
            inline
            switch
          >
            Добавить ссылку на личный кабинет
          </b-form-checkbox>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <div class="modal-order-refund-list__btns">
        <b-button
          variant="primary"
          type="submit"
          @click="onSubmit"
        >
          Отправить
        </b-button>
        <b-button
          variant="danger"
          type="submit"
          @click="hideModalFormSendEmail"
        >
          Отмена
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'PrepareFormSendEmail',
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'orderData',
    event: 'update:order-data',
  },
  props: {
    orderData: {
      type: Object,
      required: true,
    },
    prepareSendEmail: {
      type: Function,
      required: true,
    },
  },
  setup(props, context) {
    const BLANK_FORM_DATA = {
      name: props.orderData?.user?.name,
      email: props.orderData?.user?.email,
      is_add_link: 1,
    }

    const FORM_DATA = ref(JSON.parse(JSON.stringify(BLANK_FORM_DATA)))
    const resetFormSendEmailData = () => {
      FORM_DATA.value = JSON.parse(JSON.stringify(BLANK_FORM_DATA))
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetFormSendEmailData)

    const hideModalFormSendEmail = () => { context.refs['modal-prepare-form-send-email'].hide() }
    const onSubmit = () => {
      props.prepareSendEmail(FORM_DATA.value)
      hideModalFormSendEmail()
    }

    return {
      FORM_DATA,
      onSubmit,
      hideModalFormSendEmail,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>
